import { takeLatest, call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  getListProjectRequested,
  getListProjectSucceeded,
  getListProjectFailed,
  //
  getProjectRequested,
  getProjectSucceeded,
  getProjectFailed,
  //
  createProjectRequested,
  createProjectSucceeded,
  createProjectFailed,
  //
  updateProjectRequested,
  updateProjectSucceeded,
  updateProjectFailed,
  //
  uploadPosterRequested,
  uploadPosterSucceeded,
  uploadPosterFailed,
} from '../reducers/project.slice';
import ProjectAPIService from '../../services/project.service';

function* getAll(): Generator<unknown, void, unknown> {
  try {
    const service = new ProjectAPIService();
    const data = yield call([service, service.getAll]);

    yield put({ type: getListProjectSucceeded.type, payload: data });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({
      type: getListProjectFailed.type,
      payload: { message: error.message },
    });
  }
}

function* getById(action: PayloadAction<{ id: number }>): Generator<unknown, void, unknown> {
  try {
    const service = new ProjectAPIService();
    const data = yield call([service, service.getById], action.payload.id);

    yield put({ type: getProjectSucceeded.type, payload: data });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({
      type: getProjectFailed.type,
      payload: { message: error.message },
    });
  }
}

function* create(action: PayloadAction<{ type: string }>): Generator<unknown, void, unknown> {
  try {
    const { type } = action.payload;
    const service = new ProjectAPIService();
    const data = yield call([service, service.create], type);

    yield put({ type: createProjectSucceeded.type, payload: data });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({
      type: createProjectFailed.type,
      payload: { message: error.message },
    });
  }
}

function* update(action: PayloadAction<{ project: Project }>): Generator<unknown, void, unknown> {
  try {
    const { project } = action.payload;
    const service = new ProjectAPIService();
    const data = yield call([service, service.update], project);

    yield put({ type: updateProjectSucceeded.type, payload: { project: data } });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({
      type: updateProjectFailed.type,
      payload: { message: error.message },
    });
  }
}

function* uploadPoster(action: PayloadAction<{ project: Project; file: File }>): Generator<any, void, any> {
  try {
    const { project, file } = action.payload;
    const service = new ProjectAPIService();

    if (!project?.id) throw new Error('Project id invalid');

    const { signedUrl, fileName } = yield call([service, service.getSignedUrl], project.id, file.name);
    yield call([service, service.uploadBySignedUrl], signedUrl, file);

    const newProject = {
      ...project,
      fileName: fileName,
    };

    const data = yield call([service, service.update], newProject);

    yield put({ type: uploadPosterSucceeded.type, payload: data });
  } catch (error: any) {
    yield put<{ type: string; payload: SagaError }>({
      type: uploadPosterFailed.type,
      payload: { message: error.message },
    });
  }
}

export default function* watchAsync() {
  yield takeLatest(getListProjectRequested.type, getAll);
  yield takeLatest(getProjectRequested.type, getById);
  yield takeLatest(createProjectRequested.type, create);
  yield takeLatest(updateProjectRequested.type, update);
  yield takeLatest(uploadPosterRequested.type, uploadPoster);
}
